import styled from 'styled-components';
import { Typography } from '@ann/web-components';

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
`;

export const FormField = styled.div`
  display: flex;
  flex-direction: column;
  gap:8px;
`;

export const HelperText = styled(Typography).attrs({
  category: 'body',
  size: 'small',
  weight: 'regular',
})`
  margin-top: ${(props) => props.theme.spacing.xs};
  color: ${(props) => props.theme.colors.textSecondary};
`;

